import { returnStatuses } from '@reveni-io/reveni-ui'

import { transactionTypes } from '@/returns/constants'

export const titles = {
  payment: '¿Cuándo se completará el pago?',
  refund: '¿Cuándo se emitirá el reembolso?',
}

export const messages = {
  paymentOnAccept: 'El cliente deberá completar el pago pendiente una vez se validen los productos a devolver.',
  paymentPendingWithLink: 'Se ha enviado una notificación al cliente con un enlace para completar el pago pendiente.',
  manualPayment:
    'Deberán contactar con el cliente y acordar el medio de pago a utilizar para saldar la deuda pendiente manualmente.',
  refundPending:
    'Se emitirá automáticamente una vez se valide la recepción de los productos y el resultado de la operación siga resultando a favor del cliente, a menos que escojan gestionarlo manualmente.',
  manualRefund: 'Deberá emitirse manualmente cuando proceda, utilizando la acción de “Emitir reembolso”.',
  instantRefundOnHold: 'Se emitirá instantáneamente tras aprobar su solicitud.',
  paymentOnHold:
    'Se enviará una notificación al cliente con un enlace para completar el pago pendiente, tras aprobar su solicitud.',
}

export const exchangeTransactionTypes = [transactionTypes.exchange, transactionTypes.mixed]

export const acceptedStatuses = [returnStatuses.accepted, returnStatuses.partiallyAccepted]

export const rejectedOrPartiallyAcceptedStatuses = [returnStatuses.rejected, returnStatuses.partiallyAccepted]

export const paymentOnAcceptExcludedStatuses = [
  returnStatuses.pending,
  returnStatuses.accepted,
  returnStatuses.partiallyAccepted,
  returnStatuses.rejected,
  returnStatuses.cancelled,
]

export const refundInProgressStatuses = [
  returnStatuses.inProgress,
  returnStatuses.shipped,
  returnStatuses.received,
  returnStatuses.forReview,
  returnStatuses.onHold,
]
